import React from 'react'
import { GridItem } from '@which/seatbelt'

import type {
  Callout as CalloutType,
  ImageWithSources,
  LatestNews,
  SubVerticalCrScamsTopicPageQuery,
} from '../../../../generated/frontend'
import { Breadcrumb } from '../../../../shared/components/Breadcrumb/Breadcrumb'
import { Callout } from '../../../../shared/components/Callout/Callout'
import { CRScamsEmotionalSupport } from '../../../../shared/components/CRScamsEmotionalSupport/CRScamsEmotionalSupport'
import { CRScamsSignUp } from '../../../../shared/components/CRScamsSignUp/CRScamsSignUp'
import { HeroImage } from '../../../../shared/components/HeroImage/HeroImage'
import { JumplinksInline } from '../../../../shared/components/JumplinksInline/JumplinksInline'
import { LatestNewsCards } from '../../../../shared/components/LatestNewsCards/LatestNewsCards'
import { LocalFooter } from '../../../../shared/components/LocalFooter/LocalFooter'
import { TaxonomyConversionBanner } from '../../../../shared/components/TaxonomyConversionBanner/TaxonomyConversionBanner'
import { SubVerticalHeader } from '../../components/SubVerticalHeader'
import styles from './components.module.scss'

export const getSubVerticalCRScamsTopicComponents = (
  data: SubVerticalCrScamsTopicPageQuery['subVerticalPage'],
  latestNews?: LatestNews
) => {
  const { breadcrumb, taxonomyConversionBanner, consumerRightsFooter, callout, header } = data

  return {
    Breadcrumb: () => <Breadcrumb {...breadcrumb} />,
    SubVerticalHeader: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <SubVerticalHeader title={header?.title} intro={header?.intro} image={null as any} />
      </GridItem>
    ),
    SubVerticalJumpLinks: () => (
      <GridItem
        className={styles.crScamsTopicJumplinks}
        span={{ medium: 10, large: 10 }}
        columnStart={{ medium: 2, large: 2 }}
      >
        <JumplinksInline
          links={[
            { label: 'Help and advice', id: 'help-and-advice' },
            { label: 'Emotional support', id: 'emotional-support' },
            { label: 'Latest news', id: 'latest-news' },
          ]}
        />
      </GridItem>
    ),
    HeroImage: () => (
      <GridItem
        className={styles.CRScamsTopicHeroImage}
        span={{ medium: 10, large: 10 }}
        columnStart={{ medium: 2, large: 2 }}
      >
        <HeroImage
          {...(header?.image as ImageWithSources)}
          alt={header?.image.alt || 'scams'}
          aspectRatio="three-to-one"
        />
      </GridItem>
    ),
    CRScamsNavigation: () => (
      <GridItem span={{ large: 12 }} columnStart={{ large: 1 }} id="help-and-advice">
        <Callout
          title={callout?.title}
          items={callout?.items as CalloutType['items']}
          imageFormat={callout?.imageFormat}
        />
      </GridItem>
    ),
    CRScamsSignUp: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <CRScamsSignUp />
      </GridItem>
    ),
    CRScamsEmotionalSupport: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <CRScamsEmotionalSupport />
      </GridItem>
    ),
    CRScamsLatestNews: () => (
      <GridItem
        span={{ small: 'full-bleed', medium: 'full-bleed', large: 'full-bleed' }}
        className={styles.CRScamsLatestNews}
        id="latest-news"
      >
        <LatestNewsCards
          name="Latest scam news"
          articles={latestNews?.articles ?? []}
          viewAllData={{ text: 'View all news', href: '/news/tag/scams' }}
        />
      </GridItem>
    ),
    TaxonomyConversionBanner: () => (
      <GridItem span={{ small: 'full-bleed', medium: 'full-bleed', large: 'full-bleed' }}>
        <TaxonomyConversionBanner {...taxonomyConversionBanner} />
      </GridItem>
    ),
    ConsumerRightsFooter: () => (
      <GridItem className={styles.CRScamsTopicFooter}>
        <LocalFooter data={consumerRightsFooter} />
      </GridItem>
    ),
  }
}
